import {
  arrayUnion,
  collection,
  doc,
  onSnapshot,
  serverTimestamp,
  updateDoc
} from "firebase/firestore";
import { db } from "../firebase";

export const subscribeDemoRequestTasks = (onData, onError) => onSnapshot(
  collection(db, "managementTasks"),
  (snapshot) => {
    const tasks = snapshot.docs
      .map((item) => ({ id: item.id, ...item.data() }))
      .filter((item) => item.type === "demo_request")
      .sort((a, b) => (b.updatedAt?.toMillis?.() || 0) - (a.updatedAt?.toMillis?.() || 0));
    onData(tasks);
  },
  onError
);

export const updateManagementTask = (taskId, changes) => updateDoc(
  doc(db, "managementTasks", taskId),
  { ...changes, updatedAt: serverTimestamp() }
);

export const addManagementTaskNote = ({ taskId, user, note }) => updateDoc(
  doc(db, "managementTasks", taskId),
  {
    notes: arrayUnion({
      body: note.trim(),
      createdByUid: user.uid,
      createdByName: user.displayName || user.email || "Yönetim",
      createdAt: new Date()
    }),
    updatedAt: serverTimestamp()
  }
);
